import { convertDateToString } from "../../../lib/utils/dates";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    movimientos: [],
    isMovimientosLoading: true,
    filtros: {
      desde: "",
      hasta: "",
    },
    movimientoAVisualizar: null,
    movimientoConceptos: [],
  },
  mutations: {
    setMovimientos(state, payload) {
      state.movimientos = payload;
    },
    setMovimientoAVisualizar(state, payload) {
      state.movimientoAVisualizar = payload;
    },
    setDesde(state, payload) {
      state.filtros.desde = payload;
    },
    setHasta(state, payload) {
      state.filtros.hasta = payload;
    },
    setMovimientoConceptos(state, payload) {
      state.movimientoConceptos = payload;
    },
  },
  actions: {
    async getMovimientos(context) {
      const desde =
        context.state.filtros.desde.length > 0
          ? convertDateToString(context.state.filtros.desde)
          : null;
      const hasta =
        context.state.filtros.hasta.length > 0
          ? convertDateToString(context.state.filtros.hasta)
          : null;

      const response = await axios.get("/movimientos", {
        params: {
          desde: desde,
          hasta: hasta,
        },
      });

      context.commit("setMovimientos", response.data);
    },
    async getMovimientoConceptos(context) {
      const response = await axios.get("/movimientos/conceptos");

      context.commit("setMovimientoConceptos", response.data);
    },
    setDesde(context, payload) {
      context.commit("setDesde", payload);
    },
    setHasta(context, payload) {
      context.commit("setHasta", payload);
    },
    setMovimientoAVisualizar(context, payload) {
      context.commit("setMovimientoAVisualizar", payload);
    },
  },
  getters: {
    getMovimientos(state) {
      return state.movimientos;
    },
    getDesde(state) {
      return state.filtros.desde;
    },
    getHasta(state) {
      return state.filtros.hasta;
    },
    getMovimientoAVisualizar(state) {
      return state.movimientoAVisualizar;
    },
    getMovimientoConceptos(state) {
      return state.movimientoConceptos;
    },
  },
};
